<template>
    <div class="row">
        <div class="col-5 pr-0">
            <small class="text-muted">
                {{lab}}
            </small>
        </div>
        <div class="col-7 pl-1">
            <div class="card card-body p-1 border-0">
                <small>
                    <slot></slot>
                </small>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            lab: String
        }
    }
</script>

<style></style>
